import { Component, OnInit } from "@angular/core";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import {
	EventMessage,
	EventType,
	AuthenticationResult,
} from "@azure/msal-browser";
import { filter } from "rxjs/operators";
import { AppService } from "../app.service";
import * as FusionCharts from 'fusioncharts';
import { HttpClient } from "@angular/common/http";
import { BusService } from "../Bus.service";



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
	loginDisplay = false;

  dataSource: any;
  type: string | undefined;
  width: string | undefined;
  height: string | undefined;
  chartData: any;
  chartData2: any;
  res:any | undefined;
  schoolLoc: any | undefined;
  AbsDetail: any | undefined;
  location: number | undefined;
  schoolTarget: number = 0;
  caption:any;
  loading:boolean=false;

	constructor(
		private authService: MsalService,
		private msalBroadcastService: MsalBroadcastService,
    private http: HttpClient,
		private srv: AppService,
    private comm: BusService

	) {
    this.comm.Loc$.subscribe((l:any)=>{this.location = l; this.getLocation(l.lId); this.getAbsences(l.lId, 2026)})
}

//Heatmap
DailyChartCurrent = {
  "chart": {
      "caption": "Daily % Attendance Report",
      //"subcaption": "In percentage",
      // "xaxisname": "Weeks",
      "yaxisname": "Week Days",
      "xAxisLabelsOnTop": "1",
      "plottooltext":
      "<div id='nameDiv' style='font-size: 12px; border-bottom: 1px dashed #666666; font-weight:bold; padding-bottom: 3px; margin-bottom: 5px; display: inline-block; color: #888888;' ><b>$rowLabel </b>{br}$trLabel</div>{br}PCT: <b>$dataValue</b>{br} <b> $tlLabel</b>{br}<b></b>",
      "showValues":"1",
      "showBorder": "0",
      // "showLegend":"0",
        // "mapbycategory":"1",
      "labelDisplay": "rotate",
      // "showLabels": "1",
      "legendBgAlpha": "0",
      "legendBorderAlpha": "0",
      // "legendShadow": "0",
      "legendItemFontSize": "10",
      // "showPercentInTooltip": "0",
      "decimals": "1",
     // "numbersuffix": "%",
      "valueFontColor": "000000"
 }, "rows": {
    "row": [{
      "id": "Monday",
      "label": "MONDAY"
    }, {
      "id": "Tuesday",
      "label": "TUESDAY"
    }, {
      "id": "wednesday",
      "label": "WEDNESDAY"
    }, {
      "id": "Thursday",
      "label": "THURSDAY"
    }, {
      "id": "Friday",
      "label": "FRIDAY"
    }]
  },
  "columns": {
      "column": [
          {
              "id": "1",
              "label": "Wk1"
          },
          {
              "id": "2",
              "label": "Wk2"
          },
          {
              "id": "3",
              "label": "Wk3"
          }
      ]
  },
  "dataset": [
      {
          "data": [
              {
                  "rowid": "Mon",
                  "columnid": "1",
                  "value": "35",
                  "tlLabel": "Memorial Day",
                  "colorRangeLabel": "HOLIDAY"
              },
              {
                  "rowid": "Tue",
                  "columnid": "1",
                  "value": "95",
                  "colorRangeLabel": "ABOVE TARGET"
              },
              {
                  "rowid": "Wed",
                  "columnid": "1",
                  "value": "17",
                  "colorRangeLabel": "HOLIDAY"
              },
              {
                  "rowid": "Th",
                  "columnid": "1",
                  "value": "55.98",
                  "colorRangeLabel": "BELOW TARGET"
              }
          ]
      }
  ],
  "colorrange": {
     // "mapByCategory": "1",
      "gradient": "0",
      //code: "E24B1A",
      "startlabel": "Holiday",
      "endlabel": "Above Target",
     // "minvalue": "0",
      "color": [
        {
          "code": "ffffff",
          "minvalue": "1",
          "maxvalue": "1",
          "label": "1 - HOLIDAY"
      },
      {
          "code": "B41527",
          "minvalue": "51",
          "maxvalue": "92.9999",
          "label": "WELL BELOW TARGET (> 2% below target)"
      },
      {
          "code": "E48739",
          "minvalue": "93",
          "maxvalue": "94.9999",
          "label": "SLIGHTLY BELOW TARGET  (< 2% below target)"
      },
      {
          "code": "399E38",
          "minvalue": "95",
          "maxvalue": "100",
          "label": "ABOVE TARGET"
      },
      {
        "code": "D3D3D3 ",
        "minvalue": "0",
        "maxvalue": "0",
        "label": "0 - PENDING"
      }
      ]
  }
}
// Chart Configuration
dataSource3 = {
  chart: {
    caption: "Grading Periods Rate Trend", //Set the chart caption
    subCaption: "", //Set the chart subcaption
    xAxisName: "Quarters", //Set the x-axis name
    yAxisName: "Atendance Percentage", //Set the y-axis name
    "yAxisMaxValue":"100",
    "yAxisMinValue":"90",
    numberSuffix: "%",
    theme: "fusion", //Set the theme for your chart
    decimals: "2",
    palettecolors: "#f8bd19,#008ee4,#33bdda,#e44a00,#6baa01,#583e78"
  }, data:[{ "label": "1st" , "value": ""}, { "label": "2nd", "value": "" }, { "label": "3rd", "value": "" }, { "label": "4th", "value": "" }]

}
// Linechart 2 Weekly
dataSource4 = {
    chart: {
      rotateLabels: "1",
      labelDisplay: "wrap",
      caption: "Grading Period Weekly Trend Rate", //Set the chart caption
      subCaption: "", //Set the chart subcaption
      xAxisName: "Weeks", //Set the x-axis name
      yAxisName: "Atendance Percentage", //Set the y-axis name
      yAxisMaxValue:"100", // Set max value for Y Axis
      yAxisMinValue:"90", // Set min value for Y-Axis
      numberSuffix: "%",
      theme: "fusion", //Set the theme for your chart
      palettecolors: "#f8bd19,#008ee4,#33bdda,#e44a00,#6baa01,#583e78",
    },
     data: [
      {
        label: "Week 1", value: "", tooltext:""
      },
      {
        label: "Week 2", value: "", tooltext:""
      },
      {
        label: "Week 3", value: "", tooltext:""
      },
      {
        label: "Week 4", value: "", tooltext:""
      },
      {
        label: "Week 5", value: "", tooltext:""
      },
      {
        label: "Week 6", value: "", tooltext:""
      },
      {
        label: "Week 7", value: "", tooltext:""
      },
      {
        label: "Week 8", value: "", tooltext:""
      },
      {
        label: "Week 9", value: "", tooltext:""
      },
      {
        label: "Week 10", value: "", tooltext:""
      },
      {
        label: "Week 11", value: "", tooltext:""
      },
      {
        label: "Week 12", value: "", tooltext:""
      },
      {
        label: "Week 13", value: "", tooltext:""
      },
      {
        label: "Week 14", value: "", tooltext:""
      },
      {
        label: "Week 15", value: "", tooltext:""
      },
      {
        label: "Week 16", value: "", tooltext:""
      },
      {
        label: "Week 17", value: "", tooltext:""
      },
      {
        label: "Week 18", value: "", tooltext:""
      },
      {
        label: "Week 19", value: "", tooltext:""
      },
      {
        label: "Week 20", value: "", tooltext:""
      },
      {
        label: "Week 21", value: "", tooltext:""
      },
      {
        label: "Week 22", value: "", tooltext:""
      },
      {
        label: "Week 23", value: "", tooltext:""
      },
      {
        label: "Week 24", value: "", tooltext:""
      },
      {
        label: "Week 25", value: "", tooltext:""
      },
      {
        label: "Week 26", value: "", tooltext:""
      },
      {
        label: "Week 27", value: "", tooltext:""
      },
      {
        label: "Week 28", value: "", tooltext:""
      },
      {
        label: "Week 29", value: "", tooltext:""
      },
      {
        label: "Week 30", value: "", tooltext:""
      },
      {
        label: "Week 31", value: "", tooltext:""
      },
      {
        label: "Week 32", value: "", tooltext:""
      },
      {
        label: "Week 33", value: "", tooltext:""
      },
      {
        label: "Week 34", value: "", tooltext:""
      },
      {
        label: "Week 35", value: "", tooltext:""
      },
      {
        label: "Week 36", value: "", tooltext:""
      },
      {
        label: "Week 37", value: "", tooltext:""
      },
      {
        label: "Week 38", value: "", tooltext:""
      },
      {
        label: "Week 39", value: "", tooltext:""
      },
      {
        label: "Week 40", value: "", tooltext:""
      },
      {
        label: "Week 41", value: "", tooltext:""
      },
      {
        label: "Week 42", value: "", tooltext:""
      },
      {
        label: "Week 43", value: "", tooltext:""
      },
      {
        label: "Week 44", value: "", tooltext:""
      },
      {
        label: "Week 45", value: "", tooltext:""
      },

    ]

  }

	ngOnInit(): void {

    // this.location = 107

    // this.getLocation(this.location); // Edgemere ES
    // this.getAbsences(this.location, 2023);
    this.caption = this.DailyChartCurrent.chart.caption;
	}

	setLoginDisplay() {
		this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
		if (this.loginDisplay) {
			//this.srv.testAPI();
		}
	}

  getAbsences(Lid:number, SY:number){
    this.loading = true;
  this.srv.getAbsenceCountDailyBySchoolByYear(Lid,SY).subscribe(r =>{
    this.AbsDetail = r ;

    this.DailyChartCurrent.chart.caption =  this.AbsDetail[0].fmtSchoolYear  + " " + this.caption
    var dsCurrent = this.AbsDetail.map((da:any)=>{ return {"rowid": da.chartRowId, "columnid": da.chartColumnId, "value": da.schoolChartValue, "tlLabel": da.dayType, "trLabel": da.fmtDate }})

    var columnsCurrent = this.AbsDetail.map((da:any)=>{ return {"id": da.chartColumnId, "label": "Wk" +da.schoolWeek  }})

    var arrayUniqueByKey:any = [...new Map(columnsCurrent.map((item:any) =>

      [item["id"], item])).values()];

    this.DailyChartCurrent.columns.column = arrayUniqueByKey;
    this.DailyChartCurrent.dataset[0].data = dsCurrent;
    this.loading=false;
})
  }


  getLocation(lo:number){

     this.srv.getLocationDetail(lo).subscribe(result=>{
       this.res =  result;

       console.log("testo!!!!") ;

        var schools: any = [];
        this.res.lstWidgets.forEach((element: any) => {
          console.log(element.lstSchools) ;
          if(element.lstSchools[0] != undefined ){

            schools.push(element.lstSchools[0]);
            if(schools[0].targetSchool)
            this.schoolTarget = schools[0].targetSchool ;
          }

        });

        this.schoolLoc = schools[0].primaryRate;

        if(this.res.primaryPeriodRate1 > 0){
          this.dataSource3.data[0].value = schools[0].primaryPeriodRate1;
        }
        if(this.res.primaryPeriodRate2 > 0){
          this.dataSource3.data[1].value = schools[0].primaryPeriodRate2;
        }
        if(this.res.primaryPeriodRate3 > 0){
          this.dataSource3.data[2].value = schools[0].primaryPeriodRate3;
        }
        if(this.res.primaryPeriodRate4 > 0){
          this.dataSource3.data[3].value = schools[0].primaryPeriodRate4;
        }

          this.updateWeekly(this.res);

    });


   }



   updateWeekly(sch:any){

    var schools: any = [];
    sch.lstWidgets.forEach((element: any) => {

      if(element.lstSchools[0] != undefined )
       schools.push(element.lstSchools[0]);
       if(element.lstSchools[1] != undefined )
       schools.push(element.lstSchools[1]);
       if(element.lstSchools[2] != undefined )
       schools.push(element.lstSchools[2]);

    });

    var attRates: any = [];
    schools.forEach((el:any) =>{
      if(el.lstWeeklyAttendanceRates != undefined)
    attRates.push(el.lstWeeklyAttendanceRates) ;
    });
    // console.log(schools);
    var currentAttRates =   attRates[0].filter( (s: any) => {
     return s.seriesName == sch.schoolYear ;
  //  alert(s.seriesName);
    }) ;

        var lstData: any = []
        var lstDataLabel: any = []
        currentAttRates.forEach( (e: any) => {
          if(e.lstData.length > 0)
        lstData.push(e.lstData);
        if(e.lstDataLabel.length > 0)
        lstDataLabel.push(e.lstDataLabel);
        // console.log(e.lstData);
        })
            // console.log(lstData) ;
        const mergeLstData: any = []
        lstData.forEach((m: any) =>{
          mergeLstData.push(...m)
          // console.log(m) ;
        })

        const mergeLstDataLabel: any = []
        lstDataLabel.forEach((m: any) =>{
          mergeLstDataLabel.push(...m)
          // console.log(m) ;
    });


    for(let i = 0 ; i < mergeLstData.length; i++){
      this.dataSource4.data[i].value = mergeLstData[i] ;
    this.dataSource4.data[i].tooltext = mergeLstDataLabel[i] ;
    }


  }


}
